import { overlay } from 'overlay-kit';
import { openOverlayOnceAsync } from '@/shared/utils/openOverlayOnce';
import type { QuizPickerOptions } from './types/quizPicker.types';
const OVERLAY_ID = 'quiz-picker-modal';

/**
 * 내 퀴즈에서 하나를 고르는 모달을 연다.
 *
 * 닫힐 때 resolve 된다. 고른 결과는 `onSelect` 로 받는다 — 고른 뒤 처리가 실패해
 * 모달을 열어 둬야 하는 경우가 있다.
 */
export async function showQuizPickerModal(options: QuizPickerOptions) {
  const {
    QuizPickerModal
  } = await import('./components/QuizPickerModal');
  await openOverlayOnceAsync<void>(OVERLAY_ID, ({
    close
  }) => <QuizPickerModal {...options} onClose={() => close()} />);
  overlay.unmount(OVERLAY_ID);
}